import useInView from './useInView';

// A single skill icon + label that fades/slides in each time it scrolls into
// view.
const SkillItem = ({ skill, index }) => {
    const [ref, inView] = useInView();

    return (
        <div
            ref={ref}
            className={`skill-item flex flex-col items-center justify-start ${
                inView ? 'is-visible' : ''
            }`}
            // stagger each item within its row for a gentle cascade
            style={{ transitionDelay: `${(index % 5) * 80}ms` }}>
            <i className={`${skill.logo} text-6xl sm:text-7xl lg:text-8xl`}>
                {skill.iconText}
            </i>
            <p className='text-sm lg:text-2xl mt-3'>{skill.name}</p>
        </div>
    );
};

export default SkillItem;
